import { render } from "./ViewEquipMarchandPage.vue?vue&type=template&id=65b9d52a&ts=true"
import script from "./ViewEquipMarchandPage.vue?vue&type=script&lang=ts"
export * from "./ViewEquipMarchandPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__